import { Link } from 'react-router-dom';

const Logo = () => {
  return (
    <Link to={'/'} className="font-semibold text-blue-800 text-[25px]">
      M<span className="text-red-600">e</span>est
      <div className="h-[2px] w-full bg-red-500"></div>
      <div className="text-[15px] font-normal">Helper</div>
    </Link>
  );
};

export default Logo;
